import { JetView, plugins } from 'webix-jet'; // Import necessary modules from webix-jet
import MenuView from 'jet-views/menu'; // Import MenuView component
import ToolView from 'jet-views/toolbar'; // Import ToolView component

/**
 * ReportsLeagueView class extends JetView to create a view for reports.
 */
export default class ReportsLeagueView extends JetView {
    /**
     * Configures the layout of the view.
     * @returns {Object} The configuration object for the view.
     */
    config() {
        const _ = this.app.getService('locale')._; // Localization service for translations
        return {
            type: 'wide', // Layout type
            cols: [
                {
                    localId: 'inner:layout', // Local ID for inner layout
                    type: 'wide', // Inner layout type
                    rows: [
                        {
                            view: 'tabbar', // Tabbar component for navigation
                            localId: 'tabbar', // Local ID for tabbar
                            height: 43, // Height of the tabbar
                            tabMinWidth: 190, // Minimum width for tabs
                            tabMoreWidth: 80, // Width for 'more' tab
                            moreTemplate: function () {
                                // Template for 'more' tab
                                return (
                                    "<div style='font-weight: bold;border-left: 1px solid #ebedf0;height: 30px;line-height: 2;padding-left: 5px;color: #263043;'>" +
                                    _('Ver más') + // Translated text for 'more'
                                    '</div>'
                                );
                            },
                            options: [
                                // Options for the tabbar
                                {
                                    id: 'leagues.reports.userAfilliatesReport', // ID for user affiliates report
                                    value: _('Reporte de Usuarios'), // Translated label for the report
                                },
                                {
                                    id: 'leagues.reports.betsReport', // ID for bets report
                                    value: _('Reporte de Apuestas'), // Translated label for the report
                                },
                                {
                                    id: 'leagues.reports.casinoGamesReport', // ID for casino games report
                                    value: _('Reporte de Casino'), // Translated label for the report
                                },
                            ],
                        },
                        { $subview: true }, // Placeholder for subview
                    ],
                },
            ],
        };
    }

    /**
     * Initializes the view and sets up event listeners.
     */
    init() {
        this.use(plugins.Menu, this.$$('tabbar')); // Use Menu plugin with the tabbar
        this.on(
            this.app,
            'person:select',
            (
                person, // Event listener for person selection
            ) => this.setParam('user', person.id, true), // Set user parameter based on selected person
        );
    }
}

// FILE DOCUMENTED
